module.exports = __webpack_public_path__ + "static/knotek-8b48358e696f45e1de6ae7edef272383.jpg";